// extracted by mini-css-extract-plugin
export default {"smallBubbleContainer":"smallbubble_smallBubbleContainer__asoa8"};